import SeasonsTab from "./sub_tabs/SeasonsTab";


const chooseSeasonTabRouter = {

  season: 
  {
    title: 'Seasons',
    element: <SeasonsTab />
  }

}

export default chooseSeasonTabRouter;